import styled from 'styled-components';
import { Text14Bold, Text16Light } from '../utils/Text/Text.styles';
import NumericInput from '../utils/inputs/NumericInput/NumericInput';
import { theme } from '../../styles/constants';
import Select from '../utils/Select/Select';

export const MediaContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #f3f4f6;
  width: 100%;
  padding: 0.8rem;
  position: relative;
  display: flex;
  margin-bottom: 1.2rem;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

export const MediaContentContainer = styled.div`
  min-width: 18rem;
  max-width: 18rem;
  height: 20rem;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f3f4f6;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CloseWrapper = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: rgba(17, 25, 39, 0.5);
  padding: 0.4rem;
`;

export const ProgressContainer = styled.div`
  inset: 0;
  position: absolute;
  background: rgba(7, 13, 18, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProgressContent = styled.div`
  width: 11rem;
  height: 11rem;
`;

export const Error = styled.div`
  position: absolute;
  inset: 0;
  background-color: #00000090;
  padding: 2px 2px 4px 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ErrorText = styled(Text14Bold)`
  letter-spacing: -0.42px;
  color: white;
`;

export const ErrorMessageText = styled(Text16Light)`
  letter-spacing: -0.42px;
  color: white;
`;

export const Content = styled.div`
  width: 100%;
  margin-left: 0.4rem;
  padding: 0 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 500px) {
    margin-top: 1rem;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;
  align-items: center;
  min-height: 6.9rem;

  @media only screen and (max-width: 500px) {
    min-height: unset;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const NumberInput = styled(NumericInput)`
  width: unset;

  p {
    font-size: 1.2rem;
    font-weight: 300;
  }

  input {
    border-radius: 8px;
    border: 1px solid ${({ $error }) => ($error ? theme.colors.error : '#f3f4f6')};
    height: 3.6rem;
    width: 8rem;
    font-size: 1.4rem;
    padding: 0.4rem 0.8rem;
    padding-left: 1.6rem;
  }
`;

export const StyledSelect = styled(Select)`
  width: 24rem;
`;
